import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';
import styles from './SectionBar.module.css';

interface SectionBarProps {
  children: ReactNode;
  /**
   * `solid` — the full green band, for a page's primary divisions.
   * `mid`   — the lighter green band, for a secondary division inside a card.
   * `light` — an underlined label, for everything else. Default.
   */
  variant?: 'solid' | 'mid' | 'light';
  /** Trailing slot: a count, a hint like "deslize ↔", or an action. */
  aside?: ReactNode;
  /** Renders `aside` as an action (gold on solid, green on light). */
  asideIsAction?: boolean;
  id?: string;
}

export function SectionBar({
  children,
  variant = 'light',
  aside,
  asideIsAction = false,
  id,
}: SectionBarProps) {
  const isSolid = variant === 'solid' || variant === 'mid';
  return (
    <div
      className={cx(isSolid ? styles.solid : styles.light, variant === 'mid' && styles.mid)}
      id={id}
    >
      <h2 className={styles.title}>{children}</h2>
      {aside != null && (
        <span className={asideIsAction ? styles.action : styles.aside}>{aside}</span>
      )}
    </div>
  );
}
